var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    }
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { Page } from "../../lib/page-component";
import "../../components/header";
import "../../components/leftMenu";
import KnockoutModel from "../../lib/knockout_model";
import "../../components/paging";
import * as ajax from "../../app-lib/ajax_proxy";
import './marketAndOpponentAnalysis.css';
import * as Configs from "../../app-lib/constants";
import "../../components/paging";
import '../../lib/knockout_datePicker';
import '../../lib/knockout_fileUpload';
var marketAndOpponentAnalysis = /** @class */ (function (_super) {
    __extends(marketAndOpponentAnalysis, _super);
    function marketAndOpponentAnalysis(root) {
        var _this = _super.call(this, "/api/market", root, { dateType: 0, pageIndex: 1, type: 0, content: '' }) || this;
        _this.KeyWord = ko.observable(); //搜索字段
        _this.mserachType = ko.observableArray([{ text: '区域名称', val: 1 }, { text: '地理位置', val: 2 }, { text: '经济概况', val: 3 }, { text: '编制人员', val: 4 }, { text: '编制日期', val: 5 }]); //市场搜索拉我下
        _this.marketTypeVal = ko.observable(); //类型值
        _this.leadurl = ko.observable('/api/message/upload'); //上传文件地址
        _this.showTimeSelect = ko.observable(false); //日期框
        _this.preparationDate = ko.observable(); //编制日期搜索
        _this.choose_index = ko.observableArray(); //选中的用户
        return _this;
    }
    marketAndOpponentAnalysis.prototype.ponUploaded = function (d, r) {
        console.log(d, r);
    };
    // 下拉改变
    marketAndOpponentAnalysis.prototype.cgSearch = function () {
        this.preparationDate('');
        if (this.marketTypeVal() == 5) {
            this.showTimeSelect(true);
        }
        else {
            this.showTimeSelect(false);
        }
    };
    // 删除一条数据
    marketAndOpponentAnalysis.prototype.deleteOneData = function (r) {
        var _this = this;
        // console.log('确认删除',r)
        window.popBox.show('是否删除该条数据', { isConfirmModal: true, showFooter: true }).then(function (d) {
            console.log('确认删除');
            ajax.deleteIt('/api/market/' + r.id).then(function (d) {
                if (d.status == '0')
                    window.popBox.show('删除成功');
                _this.loadData();
            });
        });
    };
    // 搜索
    marketAndOpponentAnalysis.prototype.searchList = function () {
        if (!this.showTimeSelect()) {
            this.data.content = this.KeyWord();
        }
        else {
            if (this.preparationDate()) {
                this.data.content = this.preparationDate();
            }
            else {
                return window.popBox.show('请选择编辑日期');
            }
        }
        this.data.pageIndex = 1;
        this.data.type = this.marketTypeVal();
        // this.data.content = this.KeyWord();
        this.loadData();
    };
    // opponent
    // 时间正序排列
    marketAndOpponentAnalysis.prototype.areast = function () {
        this.data.dateType = 1;
        this.loadData();
    };
    // 时间倒序排列
    marketAndOpponentAnalysis.prototype.areain = function () {
        this.data.dateType = 0;
        this.loadData();
    };
    marketAndOpponentAnalysis.prototype.ExportChose = function (res, index) {
        if (this.choose_index.indexOf(index) == -1) {
            this.choose_index.push(index);
        }
        else {
            this.choose_index.remove(index);
        }
        return true;
    };
    // ie设置
    marketAndOpponentAnalysis.prototype.ieS = function () {
        var userAgent = navigator.userAgent; //取得浏览器的userAgent字符串  
        var isIE = userAgent.indexOf("compatible") > -1 && userAgent.indexOf("MSIE") > -1; //判断是否IE<11浏览器
        if (isIE) {
            var reIE = new RegExp("MSIE (\\d+\\.\\d+);");
            reIE.test(userAgent);
            var fIEVersion = parseFloat(RegExp["$1"]);
            if (fIEVersion == 7) {
                return true;
            }
            else if (fIEVersion == 8) {
                return true;
            }
            else if (fIEVersion == 9) {
                return true;
            }
            else if (fIEVersion == 10) {
                return true;
            }
            else {
                return false;
            }
        }
        else {
            return false;
        }
    };
    //用户管理全选
    marketAndOpponentAnalysis.prototype.btn_choose_all = function (event) {
        var vm = this.viewModel();
        // debugger;
        if (this.ieS()) {
            if (event.srcElement.checked) {
                for (var i in vm.data.list) {
                    if (this.choose_index.indexOf(vm.data.list[i].id < 1)) {
                        this.choose_index.push(vm.data.list[i].id);
                    }
                }
            }
            else {
                this.choose_index.removeAll();
            }
        }
        else {
            if (event.target.checked) {
                // this.choose_index.removeAll();
                for (var i in vm.data.list) {
                    if (this.choose_index.indexOf(vm.data.list[i].id < 1)) {
                        this.choose_index.push(vm.data.list[i].id);
                    }
                }
            }
            else {
                this.choose_index.removeAll();
            }
        }
        return true;
    };
    // 导出excel
    marketAndOpponentAnalysis.prototype.exportExcel = function () {
        if (this.choose_index().length < 1) {
            return window.popBox.show('至少选择一条数据');
        }
        console.log(this.choose_index());
        var str = '';
        for (var i = 0; i < this.choose_index().length; i++) {
            if (i < 1) {
                str = this.choose_index()[0];
            }
            else {
                str = str + ',' + this.choose_index()[i];
            }
        }
        window.open(Configs.Configs.serviceUrl + '/api/market/export?id=' + str);
    };
    return marketAndOpponentAnalysis;
}(KnockoutModel));
var DemoModel = /** @class */ (function (_super) {
    __extends(DemoModel, _super);
    function DemoModel() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    DemoModel.prototype.init = function () {
        this.vm = new marketAndOpponentAnalysis(this.container.querySelector('.marketAndOpponentAnalysis'));
        console.log("eeeeeeeee");
        this.vm.bind();
    };
    DemoModel.prototype.update = function (arg) {
        this.vm.choose_index([]);
        this.vm.data.pageIndex = 1;
        this.vm.data.content = '';
        this.vm.KeyWord('');
        this.vm.loadData();
        return Promise.resolve();
    };
    DemoModel.prototype.onInitComplete = function () {
    };
    return DemoModel;
}(Page));
export default DemoModel;
